const HB_FILTER_REQUEST = [
  'mdf-node/uniform/makeBill/getBatchDoProcess', // 定时任务
  '/monitor/record', // 监控相关
  'api/v1/yyeye/spans', // 哈勃录制前端上报
  'ymcexclude=1', // 排除标识
  'heartbeat/ping', // 工作台定时任务
  'heartbeat/yms', // 工作台定时任务
  'option/log', // 工作台统计接口
  'collect/ubaInfo', // uba上报地址
  'api/browser', // 友云音SDK上报接口
  '/uba/collect/', // uba服务接口
  'ubasdk-fe/', // uba资源文件
  '/ubasdk/', // uba资源文件
  'art.diwork.com', // 易观的专属化地址
  'art.yonyoucloud.com', // 易观的专属化地址
  '/sockjs-node/', // 开发环境热更新相关

  'miao.baidu.com',

  // 以下规则复用友云音的过滤list
  'localhost',
  '127.0.0.1',
  ':17752', // unknown
  ':9655', // CA证书服务端口
  '/public/lang/', // 多语资源
  'queryalertmessages', // 告警消息
  'workBenchMessagePushAction.do', // 推送消息
  '/my-salary/main/', // ncc敏感业务不进行采集
  'querypersonsettings.do', // unknown
  'sessionalive.do', // unknown
];
export default HB_FILTER_REQUEST;
